var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "carousel-bullet-nav" }, [
    _c(
      "ul",
      { staticClass: "u-reset carousel-bullet-nav--bullets" },
      _vm._l(_vm.numItems, function(bullet, bulletIdx) {
        return _c("li", { staticClass: "carousel-bullet-nav--bullet" }, [
          _c(
            "button",
            {
              staticClass: "carousel-bullet-nav--bullet-link",
              class: [
                _vm.bemAdd(
                  _vm.activeIdx === bulletIdx ? "is-active" : "",
                  "bullet-link"
                )
              ],
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.changeHandler(bulletIdx)
                }
              }
            },
            [_c("span", { staticClass: "carousel-bullet-nav--bullet-icon" })]
          )
        ])
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03b9b88e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03b9b88e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./vehi-industriepfad/assets/src/js/app/framework/components/ui/carousel/carousel-bullet-nav/index.vue
// module id = 433
// module chunks = 5